import React, { useEffect, useState, useRef } from 'react';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  TypingIndicator,
  MessageInput,
} from '@chatscope/chat-ui-kit-react';
import { HashLoader } from 'react-spinners';
import { useParams } from 'react-router-dom';
import { Box, Icon, ScaleFade } from '@chakra-ui/react';
import { GiVintageRobot } from 'react-icons/gi';
import { ChatGPtResponse,getChatgptKey,processMessageToChatGPT,QuestFinder } from 'utils/game/gameService';
import { useToast } from '@chakra-ui/react';
import { getChats, storeChat } from 'utils/translatechatgpt/translate';
import * as mammoth from 'mammoth';
import * as XLSX from 'xlsx';
import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import JSZip from 'jszip';
// import { GPT_API_KEY } from 'config/constant';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
interface ChatPopupProps {
  messages: any[];
  isTyping: boolean;
  onSend: (message: string, hidden: boolean) => void;
  onClose: () => void;
  showGpt: any;
  setShowGpt: any;
  setMessages: any;
  setChatNote: any;
  chatNote: any;
  setShowChat: any;
  showChat: any;
  setLoading: any;
  loading: any;
}

// const API_KEY = 'sk-qCVjoAh4cAvXmoTZjWjbh0WTs-arVyZmT1nVwrndfBT3BlbkFJNVDsdzR_RAXLvtLaHTT0pxQSRoa82xsm67kV8ajQYA';
// const API_KEY = GPT_API_KEY;
// const API_KEY = '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';

const ChatPopup: React.FC<ChatPopupProps> = ({
  messages,
  isTyping,
  onSend,
  onClose,
  setShowGpt,
  showGpt,
  setMessages,
  setChatNote,
  chatNote,
  setShowChat,
  showChat,
  loading,
  setLoading,
}) => {
  const [trans, setTrans] = useState(true);
  // const [API_KEY, setApiKey] = useState<string | null>(null);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);
  const allowedExtensions = [
    'ppt',
    'pptx',
    'xls',
    'xlsx',
    'txt',
    'doc',
    'docx',
    'pdf',
  ];
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const handleFile = (file: File) => {
    const extension = file.name.split('.').pop()?.toLowerCase();
    const isWithinSizeLimit = file.size <= MAX_FILE_SIZE;
    if (!extension || !allowedExtensions.includes(extension)) {
      setFileError('Only PPT, Excel, TXT, Word, and PDF files are allowed.');
      setUploadedFile(null);
    } else if (!isWithinSizeLimit) {
      setFileError('File size must be less than 5MB.');
      setUploadedFile(null);
    } else {
      setFileError(null);
      setUploadedFile(file);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      handleFile(file);
    }
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (file) {
      handleFile(file);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setTrans(false);
    }, 1000);
  }, []);

  const toast = useToast();
  const [formData, setFormData] = useState({
    topic: '',
    decisionPoints: '',
    options: '',
    Quest: '1', 
    setting: '',
  });
console.log(formData,'formDatainchatgpt')
  const [prompt, setPrompt] = useState('');
  const [apiResponse, setApiResponse] = useState('');
  const { id } = useParams();
  const newid = id;
  console.log(newid,'newidinchatgpot')

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
// useEffect(() => {
//   const fetchKey = async () => {
//     try {
//       const data = await getChatgptKey(); // ✅ already parsed JSON
//       setApiKey(data.key); // set API_KEY from backend
//     } catch (err) {
//       console.error("Error fetching key:", err);
//     }
//   };
//   fetchKey();
// }, []);

  // console.log("API_KEY in state:", API_KEY);
 
 
  // async function processMessageToChatGPTs(jsonPrompt: string) {
  //   const response = await processMessageToChatGPT (jsonPrompt) 
  //    console.log(response,'responseinbutton')
  //   // const data:any =  response();
  //   return response;
  // }
  async function processMessageToChatGPTs(jsonPrompt: string) {
  if (!jsonPrompt || typeof jsonPrompt !== "string") {
    throw new Error("Prompt must be a non-empty string");
  }
  return await processMessageToChatGPT({ prompt: jsonPrompt });
}


  const messageListRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const list = messageListRef.current;
    if (list) {
      list.scrollTop = list.scrollHeight;
    }
  }, [messages]);

  function stripHtmlTags(input: string) {
    const div = document.createElement('div');
    div.innerHTML = input;
    return div.textContent || div.innerText || '';
  }
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const scrollWrapper = document.querySelector(
      '.scrollbar-container',
    ) as HTMLElement;
    if (scrollWrapper) {
      scrollWrapper.style.height = isTyping ? 'auto' : 'auto';
      scrollWrapper.scrollTop = scrollWrapper.scrollHeight;
    }
  }, [messages, showGpt, isTyping]);

  const [lastMessageContent, setLastMessageContent] = useState('');
  const lastMessageRef = useRef<HTMLDivElement | null>(null);
  const hasMounted = useRef(false);

  useEffect(() => {
    if (messages.length > 0) {
      const newestMessage = messages[messages.length - 1].message;

      if (newestMessage !== lastMessageContent) {
        if (lastMessageRef.current) {
          lastMessageRef.current.scrollIntoView({
            behavior: hasMounted.current ? 'auto' : 'auto',
            block: 'end',
          });
        }

        setLastMessageContent(newestMessage);
      }

      hasMounted.current = true;
    }
  }, [messages, showGpt]);

  useEffect(() => {
    if (showGpt) {
      setTimeout(() => {
        if (lastMessageRef.current) {
          lastMessageRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'end',
          });
        }
      }, 0);
    }
  }, [showGpt]);

  const inputRef = React.useRef<HTMLDivElement>(null);
  const [inputHeight, setInputHeight] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      const inputArea = document.querySelector(
        '.cs-message-input__content-editor',
      ) as HTMLElement;

      if (inputArea) {
        const currentHeight = inputArea.offsetHeight;
        const cappedHeight = Math.min(currentHeight, 80);
        setInputHeight(cappedHeight);
      }
    }, 0);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!isTyping && lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }, [isTyping]);

  const scrollToBottom = () => {
    const scrollWrapper = document.querySelector(
      '.cs-message-list__scroll-wrapper',
    ) as HTMLElement;
    if (scrollWrapper) {
      scrollWrapper.scrollTop = scrollWrapper.scrollHeight + 50;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    const previewElement = document.querySelector('.css-gbtzxi') as HTMLElement;

    if (previewElement) {
      // Store original display in dataset if not already stored
      if (!previewElement.dataset.originalDisplay) {
        previewElement.dataset.originalDisplay =
          getComputedStyle(previewElement).display || 'block';
      }

      if (loading) {
        previewElement.style.display = 'none';
      } else {
        previewElement.style.display = previewElement.dataset.originalDisplay;
      }
    }
  }, [loading]);

  useEffect(() => {
    const previewElement = document.querySelector(
      '.game-creation-preview',
    ) as HTMLElement;

    if (previewElement) {
      // Store original display in dataset if not already stored
      if (!previewElement.dataset.originalDisplay) {
        previewElement.dataset.originalDisplay =
          getComputedStyle(previewElement).display || 'block';
      }

      if (loading) {
        previewElement.style.display = 'none';
      } else {
        previewElement.style.display = previewElement.dataset.originalDisplay;
      }
    }
  }, [loading]);
  const [availableQuests, setAvailableQuests] = useState([]);
  console.log(availableQuests,'availableQuests')

useEffect(() => {
  const fetchQuests = async () => {
    try {
      const response = await QuestFinder(newid);
      console.log(response, 'QuestFinder response'); // Check what you get
      setAvailableQuests(response.quests || []); // ✅ access quests directly
    } catch (error) {
      console.error("Error fetching quests:", error);
    }
  };

  fetchQuests();
}, [newid]);
  const handleStory = async (selectedChatNote: string) => {
    setLoading(true);

    const resp = await getChats(id);



let jsonPrompt:any =`You are an expert at converting scenario-based learning narratives into structured block-based JSON for platform deployment.

Please refer to the scenario content below:
${selectedChatNote}

STRICT RULE: Check all the details inside this scenario and follow it from start to end. Do not drop or alter anything — including the Intro Note, transitions, and final learning note. Every element must be mapped exactly.

You must create exactly ${formData.decisionPoints} interaction(s) — not more, not less.

Each interaction must include exactly ${formData.options} option(s) — not more, not less.

Even if the uploaded file includes more, only generate what is requested.

If only 1 interaction or 1 option is requested, generate exactly one — no more, no less.

Use only these animations: Talking, Asking, Agreeing, Saying No, Happy, Disappointed, Angry and Talking02. Do not use or invent any others.

Please take this scenario in natural narrative style (based on dialogue, character interactions, and option-response-feedback flow) and convert it into a structured JSON format with 3 sections using the following rules:

Return the entire output as a single JSON object with three top-level keys:

- story: All numbered dialogue, interaction, and note blocks in sequence
- overview: Metadata like title, skills, storyline, learning_outcomes, npc_name, and category (always use "General" as the default category)
- completion: Metadata like badge_name, completion_message_default, completion_message_max, completion_message_mid, completion_message_low, takeaways, and thank_you_message

You must return the output in a single JSON object with exactly three top-level keys: "overview", "story", and "completion".

If any section is missing, validation fails, or formatting is incorrect, you must regenerate the entire JSON from the beginning. Do not output partial responses or fallback to plain text.

The content of the 3 keys would be:

---

### A. Section 1: Overview

1. The scenario starts with the “title”, “skills”, “storyline” and “learning outcomes”

---

### B. Section 2: Story

1. The story starts with a quest id. By default, the Quest id is 1.
If the uploaded scenario contains a section labeled ### Intro Note:, always treat the content that follows as the first block in the story section, with:
- "blockid": "1.1"
- "blockSecondaryid": 1
- "blockDragSequence": "1.1"
- "type": "Note"
This intro note is mandatory and must be included even if it is brief. It sets the context for the scenario and must always be represented as the first block after the quest ID.
1. After learning outcomes, each section becomes a block with a numbered label (e.g., 1.1, 1.2, 1.3). Block numbers will always follow the 1.n sequence—they will never become 2.1, 3.1, etc., since 1 represents the quest number. 
2. **ABSOLUTE BLOCKID RULE:**
Every block in the "story" array must have a unique, strictly sequential blockid (1.1, 1.2, 1.3, ...), with no skipped or missing numbers for any reason.
    - If a feedback leads directly to the next main block (e.g., transition), do not reserve or skip a blockid for a non-existent bridging dialogue.
    - Only assign a blockid to actual content blocks (dialogue, note, interaction, etc.).
    - The next available blockid must always be used for the next real content block, regardless of branching or option count.
    - At the end, review your blockids to ensure there are no gaps or missing numbers.
    - If any blockid is missing, regenerate the entire story section.
    
    CRITICAL NO PHANTOM BLOCKS RULE: Never create an empty or placeholder block simply to preserve numbering sequence. Only assign a blockid when there is actual scenario content (dialogue, note, interaction, etc.) to be displayed. If an option’s path has no bridging or post-feedback dialogue, do not insert a blank or empty block—advance numbering to the next block for real content. Blockids must be strictly sequential with no gaps, but only for blocks with actual content.
    
3. Each block must include:
    - "blockid" (e.g., "1.2")
    - "blockSecondaryid" (the n part of 1.n blockid, e.g., 2 for blockid 1.2)
    - "blockDragSequence (same as blockid)
    - "blockleadsto" — the numeric part of the "navigate" value (e.g., if "navigate" is "1.5", then "blockleadsto" = 5) If "navigate" is "Repeat Question", "Replay point", or "Complete", then "blockleadsto" must be the same string as the "navigate" value.
    - "nextoption" — If "navigate" is a block (e.g., "1.5"), use "nextoption": "Select Block".
    Otherwise, set "nextoption" to the same as "navigate" (e.g., "Repeat Question").
4. Dialogue lines are tagged with:
    - Block X.X: Dialogue
    - Character, Dialogue, Animate, Navigate
5. Interactions are:
    - Block X.X: Interaction (question prompt)
    - Block X.X: Option A/B/C... (with Score and Correct)
    - Block X.X: Response A/B/C... (NPC’s reply)
    - Block X.X: Feedback A/B/C... (learning feedback + Navigate path)
    - All options, response and feedback within an interaction have the same blockid. They’re a part of the main interaction block.
    - Include an "optionsecondaryid" field for EACH option, starting at 1 for the first option in the narrative and increasing by 1 for EACH subsequent option in order, across all interactions. For example, in the first interaction, options may have optionsecondaryid: 1, 2, 3. In the next interaction, optionsecondaryid: 4, 5, 6, and so on. Each option in the "options" array must always include the correct current "optionsecondaryid" according to this sequence.
    - Options have a tag for score (100 for right, 0 for wrong) and for correct (whether option is correct or incorrect). Repeat questions and replay points will be zero too. Only mark the option that the feedback clearly identifies as the best or most aligned choice in the scenario as correct.
    - If an option does not have an explicit NPC response, do not treat the feedback text as the response. Feedback text must go only into the feedback field.
    - Only create an Interaction block if the scenario includes a clearly designated learner prompt, such as: “What would you say to [character]?” or “How would you respond?”
    Do not infer or guess the prompt based on tone, punctuation, or surrounding dialogue.
    Never treat rhetorical or reflective questions spoken by NPCs as interaction prompts, even if they end with a question mark. If an NPC ends their dialogue with a question and the next line is a real learner-facing prompt, treat only the next line as the Interaction block. Interaction prompts must always be clearly separated and explicitly intended for learner input.
6. Add appropriate Animate tags from among 8 animations—Use only the following 8 animations when tagging dialogue blocks: Talking, Asking, Agreeing, Saying No, Happy, Disappointed, Angry, Talking02. These are the only allowed values for the "animate" field. Do not create or invent any other animation labels, even if they describe tone or mood. If the tone is defensive, frustrated, or uncertain, choose the closest matching animation from the list above.
- Use Talking02 as a more serious version of Talking.
- Use Asking and Agreeing as conversational variations to add variety instead of overusing Talking or Talking02.
- Use Saying No only when the character is explicitly rejecting, refusing, or saying “no”—verbally or through clear refusal behavior.
- Vary animation usage across the scenario. You may use Talking, Talking02, or Asking for neutral or reflective tones—but avoid defaulting to them in all cases. Use other available animations to reflect tone, intent, and emotional context:
    - Agreeing for constructive, confident, or collaborative options—not just for explicit agreement.
    - Happy for hopeful, upbeat, or optimistic tones.
    - Disappointed for let-down, uncertain, or regretful responses.
    - Angry for frustration, assertiveness, or tension.
    - Saying No for firm rejections or objections.
- Consecutive dialogues, options, and responses can (and should) have different animations to avoid visual monotony.
- An option and its response can use different animations depending on emotional tone or character.
- Note and Feedback blocks do not include animations, as they are narrated rather than spoken by a character.
1. Use Navigate tags to specify the next block (or Replay point, Repeat question, or Complete).
2. Only assign "navigate": "Replay Point" if the feedback explicitly labels the feedback as “Replay Point Feedback” or includes a standalone line that says Replay Point. If the scenario text does not explicitly label an option as a replay point, it must be treated as a regular incorrect option and routed to a follow-up dialogue block or the next transition block.
3.  Replay & Repeat Mapping Rule:
i) Do not treat any line starting with “Note: This is a Replay Point” or “Note: This is a Repeat Question” as part of the feedback.
ii) If the scenario includes a separate line that says Repeat Question, treat it as a navigation command. Do not merge it with the feedback. Do not display it to the learner.
    
    iii) If a feedback block ends with a Replay Point directive, the system must:
    
    - Terminate that answer path immediately—do not continue to any post-feedback dialogue or transition block.
    - Do not attach or reuse bridging or transition dialogues from any other option.
    
    - The navigate field for that option must link only to the start of the interaction (Replay).
    - Never allow a Replay Point to be followed by any Dialogue block, even if present in other options’ paths.
    STRICT RULE: Each answer path must remain isolated until they merge into the shared transition dialogue. Option B must not borrow post-feedback bridging dialogue from Option C or any other path.
    
4. Mandatory Dialogue Inclusion After Feedback:
    
    After each feedback block—whether for a correct or incorrect option—always include all immediate post-feedback dialogue lines from the original scenario as separate Dialogue blocks, each with its own blockid and correct navigation flow. This must be done for *every* answer path, except for Repeat Question or Replay point scenarios (in which case, do NOT include any follow-up dialogue). Never merge or omit any lines, and never proceed to the next main block (next interaction, note, or ending) until all such bridging or transition dialogue is represented, even if there are multiple consecutive lines from the same character.
    
    - For branching or bridging dialogue after incorrect feedback, ensure the 'navigate' field channels the story seamlessly to the next main block in sequence, preserving the narrative as intended.
    - Double-check that after every feedback, you have accounted for every subsequent dialogue from the narrative, represented as its own Dialogue block, before advancing.
    - Summary: Never skip, combine, or reorder post-feedback dialogue. Their inclusion, in original order, is always required unless a Repeat or Replay direction is given.
    IMPORTANT: Absolutely every immediate dialogue block mentioned after each feedback—whether that path ultimately converges with others or not—must be included, with a unique blockid, in strict sequence following their respective feedbacks, unless that path is directed to Repeat Question or Replay Point. Never skip or combine these post-feedback dialogues. Only after these dialogues are represented should any converging transition or common dialogue be introduced. Every branch after feedback must be fully mapped with its associated next dialogue, before moving to converged or main narrative. Check final sequencing to ensure every such dialogue block is present and receives a unique blockid, even if its content matches another—do not omit blocks even when transition lines are identical.
    - STRICT RULE:
    For every feedback block in every interaction, immediately include the unique post-feedback dialogue line(s) that follow for each specific option, as their own Dialogue block(s) with unique blockid(s) (unless the next dialogue is 100% identical, word-for-word, for all options—in that case only, a single shared block may be used).
    Never merge, substitute, or omit these immediate post-feedback Player or NPC dialogues, even if they appear similar; each must be represented as its own block for its respective answer option.
    Navigation from each feedback block must go directly to its option's unique post-feedback dialogue block before any shared or converged content.
    Only after all option-specific post-feedback dialogues are present in separate blocks should you route to the next common or main block.
    - CRITICAL TRANSITION RULE: Post-feedback dialogue blocks for Option A, B, C, D and so on must never point to each other’s bridging dialogue blocks.Each must be treated as a separate path. Only after all such bridging blocks are complete may you route all paths to the true shared transition block. Never treat another option’s bridging dialogue as a shared transition. Example Clarification: If Option A’s feedback ends at block 1.3 and Option B’s feedback ends at block 1.4, and the shared post-interaction transition is block 1.5, then the paths must go: 1.3 → 1.5 and 1.4 → 1.5. They must not point to each other’s post-feedback blocks (e.g., 1.3 → 1.4). Each option must go directly to its own bridging or the shared transition, never to another option’s bridging block.
5. STRICT RULE: NO PHANTOM BRIDGING DIALOGUE RULE:

For every option, after its feedback block, you must *check the scenario content*.

- If a Player (or NPC) bridging dialogue line exists for that option, create a new, uniquely numbered Dialogue block for it.
- If NO bridging dialogue exists for that option in the scenario, do NOT insert, borrow, duplicate, or invent a bridging line from another path. In this case, the feedback block must route directly to the next main block (e.g., a transition or NPC dialogue).
- Never create or assign a bridging dialogue line to an option unless that exact line appears, in that place, after feedback for that specific option in the scenario.
- The presence or absence of bridging dialogue *must* match the original scenario exactly for each answer path.
- Example Clarification: Option A’s feedback navigates to block 1.5 (which is a unique bridging dialogue), and Option B’s feedback navigates directly to the shared transition dialogue at block 1.8 (with no bridging dialogue for Option B in the scenario), then do not insert any new dialogue after feedback for Option B. Directly link Option B’s feedback block to the shared transition at block 1.8.
- **STRICT TRANSITION BLOCKID RULE:** Do NOT allocate block numbers for options whose feedback leads directly to the transition (i.e., do not reserve a blockid or leave a gap). **Example:** If Options A, C, and D each have a bridging dialogue (blocks 1.5, 1.6, 1.7), and Option B's feedback leads directly to the transition (with no bridging dialogue), then the transition block is 1.8. Option B's feedback block's "navigate" must point directly to 1.8.
1. Bridging and Transition Handling Rule:
    - If a *bridging dialogue* is present after an option, map it as a separate Dialogue block immediately after that option’s feedback block.
    - Do not skip or drop bridging dialogue blocks for any option.
    - If multiple options contain bridging dialogues, each should link only to the shared transition dialogue, not to another option’s bridging or transition.
    - Transition dialogue should appear only after the bridging dialogue(s), and should be mapped as a shared Dialogue block for that interaction (unless branching explicitly requires otherwise).
    - If a bridging dialogue includes a player prompt like “Can you walk me through it?”, ensure the NPC’s follow-up reply is included in the next block as part of the bridging dialogue, before linking to the transition.
    - Under no circumstances should bridging or transition dialogues from one option path be reused, linked to, or merged with another path unless verbatim identical.
    - If a correct or incorrect option has no post-feedback bridging dialogue, do not insert or misassign the next common transition dialogue as its bridging step. Instead, link the feedback block directly to the shared transition.
    - Transition dialogues must appear only after all option-specific bridging lines (if any) have been represented. They must not be assigned to only one path.
2. If multiple option/feedback paths converge on a single identical next dialogue line, only create one block for that line. All relevant paths should point their 'navigate' fields to that shared blockid—do NOT create duplicate blocks for repeated text.
    - For each new dialogue, check if the exact same text (by that character) already exists in your block sequence as the next step. If so, reuse its blockid in the 'navigate' field for all converging paths.
    - This applies to all transition/bridging dialogue, including when different branches (correct/incorrect options) rejoin the shared storyline.
    - Never display the same dialogue content under separate blockids if it's unchanged and immediately follows several branching paths.
3. After each feedback, the next dialogue must be exclusive to that option path—never chain it to other options. Treat each post-feedback dialogue as a separate block. Never allow a dialogue from Option A to flow into the path of Option B.
4. Do not skip any dialogue lines present in the original narrative. Ensure dialogue blocks follow sequential block numbering and include appropriate animation and navigation tags.
5. Each block in the "story" section must have a blockid in strict ascending order (1.1, 1.2, 1.3, ...). Every time a new dialogue, feedback, note, or interaction is introduced—even if it is bridging from different option paths—use the next available block number, never skipping or duplicating a number. If a block is ever omitted or numbers are jumped, reintroduce the missing content or split/rename as needed so all blockids in the full enumeration are present and unique. 
6. STRICT RULE: After mapping every option path and post-feedback dialogue, validate that all blockids appear in strict, gapless sequence (1.1, 1.2, ..., 1.n) with no skipped or missing numbers. If any block number is missing, re-examine each feedback path and ensure every unique post-feedback dialogue (bridging or transition) for each option is present and assigned a unique blockid, even if content is similar to another path. Never merge or skip these blocks unless the next block is a verbatim, shared transition for all options. If a post-feedback bridging or dialogue block does not exist for an option in the original scenario, do not create a placeholder or empty dialogue. The feedback for that option should link directly to the next transition or shared block. Block numbers should only be assigned to real content blocks; do not insert empty blocks for the sake of numbering. 
    
    **MANDATORY EMPTY BLOCKS BAN:** Under no circumstances may any dialogue, note, or other block be created with an empty ("") or blank value for its main display field.
    **If a dialogue block would have an empty string as its dialogue, you must not create this block at all.**
    
    If feedback for any option (correct or incorrect) has no post-feedback dialogue specified in the scenario, you must route its ‘navigate’ field directly to the next transition block with content, skipping the creation of any dialogue block.
    
    **BLOCKID STRICTNESS:** You must always verify, after block generation, that there are no blocks in the story array whose main display fields (e.g., “dialogue”, “note”, etc.) are empty strings.
    **If any such block exists, you must regenerate the story, excluding them and repairing navigation accordingly.**
    
7. MANDATORY CHECK: Example clarification for blockid mapping: If Interaction block 1.4 has 4 options, and their feedbacks route as follows:
- Option A: feedback → unique bridging dialogue (1.5) → transition
- Option B: feedback → unique bridging dialogue (1.6) → transition
- Option C: feedback (no bridging) → transition
- Option D: feedback → Replay Point (no further block)
    
    The transition dialogue must be blockid 1.7, immediately following all used blockids, **not** 1.8 (which would be the option count + 1, and is incorrect). Also, 1.7 won’t be a blank blockid—it willl be the shared transition dialogue. All feedbacks that do not have a bridging dialogue must link *directly* to the transition, which takes the next available number. **Never skip a blockid or increment based on the number of options.** 
    
    Important Note: The blockids above are illustrative examples only. You need not use these exact blockids or format of numbering.
    
1. Any concluding / learning note at the end is also a separate block.
2. Before ending, double-check that your output includes:
- An Intro Note block as blockid 1.1
- Exactly ${formData.decisionPoints} Interaction blocks
- One final NPC Dialogue before the conclusion and one concluding Note before the completion section
No blocks must be skipped. All transitions must be complete.

---

### C. Section 3: Completion

1. End with a final note block that contains learning takeaways, completion messages, and a thank-you.

---

MANDATORY STRUCTURE WARNING:
DO NOT OMIT the "overview" or "completion" section.
DO NOT respond in natural language. OUTPUT MUST BE JSON ONLY.
Always start with the overview section, followed by story, and end with completion.

### Format the entire output in JSON using this structure:

{
"overview": {
"title": "...",
"skills": [...],
"storyline": "...",
"learning_outcomes": [...],
"npc_name": "...",
"category": "General"
},
"story": [
“quest”:${formData.Quest},
{
"blockid": "1.1",
"blockSecondaryid": 1,
"blockDragSequence": "1.1",
"type": "Note",
"note": "...",
"navigate": "1.2",
"blockleadsto": 2,
"nextoption": "Select Block"
},
{
"blockid": "1.2",
"blockSecondaryid": 2,
"blockDragSequence": "1.2",
"type": "Dialogue",
"character": "Player",
"dialogue": "...",
"animate": "Talking",
"navigate": "1.3",
"blockleadsto": 3,
"nextoption": "Select Block"
},
{
"blockid": "1.3",
"blockSecondaryid": 3,
"blockDragSequence": "1.3",
"type": "Interaction",
"character": "Narrator",
"question": "....",
"options": [
{
"option": "A",
"optionsecondaryid": 1,
"optiontext": "....",
"animate": "Talking",
"score": 0,
"right": "incorrect",
"response": {
"character": "....",
"responsetext": "....",
"animate": "Talking02"
},
"feedback": {
"feedbacktext": "....",
"navigate": "1.5",
"blockleadsto": 5,
"nextoption": "Select Block"
}
},
{
"option": "B",
"optionsecondaryid": 2,
"optiontext": "....",
"animate": "Asking",
"score": 100,
"right": "correct",
"response": {
"character": "....",
"responsetext": "....",
"animate": "Happy"
},
"feedback": {
"feedbacktext": "....",
"navigate": "1.5",
"blockleadsto": 5,
"nextoption": "Select Block"
}
},
{
"option": "C",
"optionsecondaryid": 3,
"optiontext": "....",
"animate": "Saying No",
"score": 0,
"right": "incorrect",
"response": {
"character": "....",
"responsetext": "....",
"animate": "Disappointed"
},
"feedback": {
"feedbacktext": "....",
"navigate": "1.5",
"blockleadsto": 5,
"nextoption": "Select Block"
}
}
]
}
],
"completion": {
"badge_name": "...",
"completion_message_default": "...",
"completion_message_max": "...",
"completion_message_mid": "...",
"completion_message_low": "...",
"takeaways": [...],
"thank_you_message": "..."
}
}

How to extend:

- For the next interaction (e.g., the next "blockid": "1.7" with options), you would use "optionsecondaryid": 4, "optionsecondaryid": 5, etc., continuing the numbering globally.
- Each option across the whole scenario has a unique, consecutive optionsecondaryid.

MANDATORY FINAL VALIDATION CHECK:

Before outputting, confirm ALL of the following—do NOT respond if any are incorrect:

1. The story starts with an Intro Note as blockid 1.1.
2. There are exactly ${formData.decisionPoints} Interaction blocks in the story, no more or less.
3. Each Interaction block contains exactly ${formData.options} options, each with a unique, sequential optionsecondaryid.
4. Every blockid is present in strict, gapless order (1.1, 1.2, 1.3...)—no skips. Blockids must always increment by 1 after each block, even if not every branch uses every block. No phantom, reserved, or skipped block numbers are allowed. NEVER skip a blockid for any reason. If a bridging dialogue is not present for an option, do not reserve or leave a gap—simply use the next available blockid for the next real content block.
5. Every immediate post-feedback dialogue is accounted for, unmerged.
6. All post-feedback dialogues are isolated. No option’s feedback may navigate to another option’s dialogue block, even if similar in tone or content.
7. For every option in every interaction: If no bridging dialogue exists for an option, the feedback block must go directly to the next main block, without any invented or borrowed Player/NPC dialogue.
8. There must never be any block (Dialogue, Note, Interaction, etc.) with an empty string or blank value—if any block has no actual scenario content, do not create it, and do not include it in the output.
9. There is a final NPC Dialogue and a concluding Note before completion.
10. Only the specified animation labels are used.
11. Overview and Completion sections follow the correct format and include required keys.
12. The JSON includes all three top-level keys: "overview", "story", and "completion".

If any check fails, regenerate the full JSON until all are satisfied. Only output the final JSON, with no additional explanation.`
    const response = await processMessageToChatGPTs(jsonPrompt);
console.log(response,'responsetowhere')
    const content = response.choices?.[0]?.message?.content;
    console.log(content,'contnettonext')

    try {
      let cleaned = '';
      const match = content.match(/```json\s*([\s\S]*?)\s*```/);

      if (match && match[1]) {
        // Case 1: JSON is inside a code block
        cleaned = match[1].trim();
      } else if (content.trim().startsWith('{')) {
        // Case 2: JSON is raw string
        cleaned = content.trim();
      } else {
        // Try to extract first {...} block manually as fallback
        const fallbackMatch = content.match(/{[\s\S]+}/);
        if (fallbackMatch) {
          cleaned = fallbackMatch[0];
        } else {
          throw new Error('No valid JSON block found in the response.');
        }
      }

      const parsedJSON = JSON.parse(cleaned);
      const data = parsedJSON;

      const id = newid;

      if (!id) {
        console.error('No valid ID found in parsedJSON.');
        return;
      }

      // const requestBody = JSON.stringify(data);
      const requestBody = JSON.stringify({
  ...data,             // keep all existing properties
  quest: formData.Quest || 1, // ✅ add quest only here
});

console.log(requestBody,'requestBodyinchatgpt')
      const response = await ChatGPtResponse(id, requestBody);
console.log(response,'responseinchatgpt')
      if (response.data?.storedBlocks?.length > 0) {
        const noteBlocks = response.storedBlocks.filter(
          (block: any) => block.blockChoosen === 'Note',
        );
      }
    } catch (error) {
      console.error('Failed to parse JSON from response content:', error);
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };
  const limitWords = (text: any, maxWords: any) =>
    text.split(/\s+/).slice(0, maxWords).join(' ');

  const estimateTokens = (text: any) => Math.ceil(text.length / 4);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!formData.topic.trim() && !uploadedFile) {
      toast({
        title: 'Please enter a topic or upload a file.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    let fileContent = '';
    if (uploadedFile) {
      const readUploadedFile = async (file: File): Promise<string> => {
        const ext = file.name.split('.').pop()?.toLowerCase();

        if (!ext) return '';

        switch (ext) {
          case 'docx': {
            const arrayBuffer = await file.arrayBuffer();
            const result = await mammoth.extractRawText({ arrayBuffer });

            return result.value.replace(/\n\s*\n/g, '\n');
          }

          case 'xlsx':
          case 'xls': {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: 'array' });

            let allSheetsText = '';

            workbook.SheetNames.forEach((sheetName) => {
              const sheet = workbook.Sheets[sheetName];
              const jsonData: any[][] = XLSX.utils.sheet_to_json(sheet, {
                header: 1,
                defval: '',
              });

              allSheetsText += `--- Sheet: ${sheetName} ---\n`;

              jsonData.forEach((row: any[], idx: number) => {
                const filteredValues = row
                  .map((cell) => String(cell).trim())
                  .filter((text) => text.length > 0 && text);

                if (filteredValues.length > 0) {
                  allSheetsText += `${filteredValues.join(' | ')}\n`;
                }
              });

              allSheetsText += '\n';
            });

            return allSheetsText;
          }

          case 'pdf': {
            const typedArray = new Uint8Array(await file.arrayBuffer());
            const pdf = await pdfjsLib.getDocument(typedArray).promise;
            let text = '';
            for (let i = 1; i <= pdf.numPages; i++) {
              const page = await pdf.getPage(i);
              const content = await page.getTextContent();
              const pageText = content.items
                .map((item) => (item as any).str)
                .join(' ');
              text += `${pageText}\n`;
            }
            return text;
          }

          case 'pptx':
          case 'ppt': {
            const zip = await JSZip.loadAsync(file);
            let pptText = '';

            const slideFiles = Object.keys(zip.files)
              .filter((name) => /^ppt\/slides\/slide\d+\.xml$/.test(name))
              .sort((a, b) => {
                const getSlideNumber = (name: any) =>
                  parseInt(name.match(/slide(\d+)\.xml$/)?.[1] || '0');
                return getSlideNumber(a) - getSlideNumber(b);
              });

            for (const name of slideFiles) {
              const content = await zip.files[name].async('string');

              const shapeMatches = [
                ...content.matchAll(
                  /<p:sp[\s\S]*?<p:txBody>([\s\S]*?)<\/p:txBody>[\s\S]*?<\/p:sp>/g,
                ),
              ];

              let titleText = '';
              const bodyTexts: string[] = [];

              for (const match of shapeMatches) {
                const fullShape = match[0];

                // Extract text
                const textMatches = [
                  ...fullShape.matchAll(/<a:t>(.*?)<\/a:t>/g),
                ];
                const text = textMatches
                  .map((m) => m[1])
                  .join(' ')
                  .trim();

                // Check if it's a title shape
                const isTitle = /<p:ph[^>]*type="title"/.test(fullShape);

                if (isTitle) {
                  titleText = text;
                } else {
                  bodyTexts.push(text);
                }
              }

              // Concatenate title and body
              pptText += `${titleText}\n${bodyTexts.join('\n')}\n\n`;
            }

            return pptText;
          }

          case 'txt': {
            const text = await file.text();
            return text;
          }
          default:
            return '';
        }
      };

      try {
        fileContent = await readUploadedFile(uploadedFile);
      } catch (error) {
        console.error('File reading error:', error);
        return;
      }
    }
    let trimmedText = fileContent;
    let tokenEstimate = 0;

    if (fileContent.trim()) {
      trimmedText = limitWords(fileContent, 15000);
      tokenEstimate = estimateTokens(trimmedText);

      if (tokenEstimate > 20000) {
        toast({
          title: 'File is too long. Please limit to approx. 15000 words.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        return;
      }
    }

    let updatedPrompt = `Treat each new user message as a new, independent message unless the latest user message specifically references earlier content (e.g., “revise,” “update,” “change,” “continue,” or any request to modify or extend a previous scenario or output). The last message in the messages array is the user’s latest request and must be given priority.
If the last user message does not refer to earlier content or request a change to previous output, disregard all prior context and respond solely to the last user message.

Assume the role of an expert at eLearning Instructional Design and Scenario Writing. You create world-class scenarios that really get people thinking. You have been tasked with creating a scenario-based course based on either the provided topic: ${formData.topic} or the parsed content shown below. Here are the steps you need to follow:

1) When creating scenario narratives, do not use informal or colloquial language. All feedback must be worded professionally to suit workplace learning and focused on actionable learning. Avoid informal metaphors, slang, or subjective descriptors.

2) If content has been provided below from a file, use that as the primary baseline content instead of the provided topic. If both topic and file content are available, prioritize the file content and treat the topic only as a supplementary theme. 

3) **STRICT RULE**: You must create exactly ${formData.decisionPoints} interaction(s) — not more, not less.Each interaction must include exactly ${formData.options} option(s) — not more, not less. Even if the uploaded file includes more, only generate what is requested. If only 1 interaction or 1 option is requested, generate exactly one — no more, no less.

4) Before beginning the scenario creation:
- Review the content below to identify its purpose, audience, and tone.
- Extract any relevant terms, roles, challenges, or behaviors mentioned.
- If the content includes any named models or frameworks, reflect them within the scenario structure, character actions, or feedback logic.
- Use the extracted content to craft the scenario in alignment with all structural and narrative rules listed below.

You may use information such as:
- The roles described
- Key behaviors or skills discussed
- Typical workplace issues or tensions outlined
- Any examples, case studies, or sample dialogues in the content

If the uploaded file includes multiple behavioral models or domain contexts (e.g., healthcare, education, corporate):
- If the topic explicitly specifies one model or setting, use only that model and setting. Do not incorporate others unless requested.
- If the topic does not specify a model or setting, default to the models, terms, and context most prominently and repeatedly emphasized in the uploaded file.

If the uploaded content includes a specific list of strategies, steps, or model components , then your scenario must explicitly apply or reflect each of them across the interactions.

Break down the listed strategies, steps, or components into separate decision points. Each interaction should focus on one distinct element of the model, behavior, or strategy—ensuring progressive coverage and realistic application of the full concept by the end of the scenario.

Unless the topic explicitly asks for it, do not omit, rename, combine, simplify, or generalize any of the key behavioral elements from the uploaded content. Similarly, do not introduce behavioral concepts, terminology, or steps that are not present in the source.

The scenario must serve as a practical simulation of the uploaded material—not just thematically inspired by it.

If the topic explicitly references or reinforces aspects of the uploaded file—such as requiring coverage of all listed / specific strategies or  steps—you must honor and follow those topic instructions precisely. In such cases, treat the topic as an extension of the file’s intent, not as a separate or secondary theme.

5) If only a topic is provided (and no file), break down the behavioral skill mentioned in the topic into 3–5 subskills, dimensions, or typical challenges. Design each interaction to focus on one of these specific subtopics, using realistic situations that reveal how the skill shows up differently in each case. Ensure the scenario covers a wide behavioral range, not just repeating the same pattern in all interactions.

6) You need to come up with a scenario and craft a simulated conversation between the player (our learner) and a non-playing character. The player will be addressed as "you" in the scenario (not by a name), and their dialogues within the main scenario body (not options) can be titled as *Player*. The non-playing character will be addressed by a fictional name. There will be only two characters in the scenario, there cannot be a third character.

7) Important: The player (learner) must be the one actively enacting the behavioral skill described in the topic (e.g., giving feedback, making a sale, resolving a conflict). The NPC is the direct recipient or stakeholder in this interaction. Unless explicitly stated otherwise in the topic, the learner is *not* mentoring, observing, or advising another person who is performing the skill. Do not introduce a third character. All scenario interactions must take place solely between the learner and the NPC. Even if the uploaded content includes multiple stakeholders, do not introduce more than one named NPC. All other characters must be referenced only through dialogue or summary, not as active participants. They must never speak, react, or share direct dialogue.

8) The entire story will follow a common path, so all branches in the story must lead back to the same outcome (see Point 12J for transition/bridging dialogue logic—this is an important point), except in case of replay points (explained below). The story must be specific, with well-developed details. The language should be natural, human, and conversational—like a real exchange between colleagues in the given setting.

9) The scenario must have ${formData.decisionPoints} decision points, called *Interactions*. Each interaction must include a simple, open-ended question such as *“What would you say to (name)?”* or *“How would you respond?”* Avoid language that hints at the goal (e.g., “What would say to help her find her blockers?”). The question should feel like a natural continuation of the prior dialogue and must not imply which behavior is correct. 

Ensure each interaction focuses on a different subskill or behavior within the broader topic. Each interaction should reflect a distinct element from the uploaded model (if file-based), or one of the subskills or challenges identified from the topic (if topic-only). Each decision should reveal a new layer of insight or challenge, helping the learner build range and depth. The difficulty of interactions can increase as we progress, and each interaction should feel like a natural continuation of the story up till then. The last interaction should naturally lead to the conclusion of the scenario.

10) Each decision point must have ${formData.options} options, of which one can be correct. The incorrect options must represent common pitfalls in those situations. The options must be worded as dialogues that the learner can select in that situation. The options should not easily give away the right answer. For each set of answer options, ensure that even the incorrect responses are plausible and could reasonably be chosen by a well-intentioned professional in the real world. Avoid using strawman or exaggeratedly poor responses—every option should represent a common perspective or mistake or decision that someone might sincerely hold or attempt in the scenario’s context. 

At least one incorrect response in each interaction should represent a well-meaning but misguided approach commonly seen among competent professionals, not just clearly negligent or dismissive behavior. This ensures the scenario reflects realistic workplace ambiguity rather than making the right answer stand out. You must include at least one Replay Point and one Repeat Question, in different interactions (explained below). Choose the most narratively appropriate and pedagogically effective spots for these.

11) Answer Position Mapping Requirement:

Before generating the options for each interaction, assign the correct answer to a different position (A, B, or C) across the three interactions. Each of the three positions must be used exactly once—no repeats.

- Do not place the correct answer in the same slot in any two interactions.
- Do not place Replay Point or Repeat Question in the same slot more than once.

Strict rule: Before writing any options, pause and decide which slot (A, B, or C) the correct answer will appear in for this interaction. Do not proceed to generate options until this position has been chosen. This rotation ensures scenario fairness and prevents learners from guessing based on answer patterns. 

12) Options can have the title *Option* (not *Player*) and be numbered as A, B, C. 
Strict Option Labeling Rule:
When writing options for each interaction, do not begin the option with “Player:” or any character name.
Each option should be labeled only as “Option A,” “Option B,” or “Option C,” followed by the option text itself.
Do not prepend “Player:”, “You:”, or any similar label to the option dialogue text.
Example:
Option A: That sounds reasonable. I’ll look into it and get back to you.

Each option must have:

12A) A corresponding response from the non-playing character, titled *Response*. This response for each option should naturally continue to the story forward.

12B) Feedback that explains why the option was right or wrong along with the concepts behind it, worded as if talking to the learner. The feedback must be detailed, and should cover specific learning outcomes. In case of wrong choices, it should really encourage the learners to do better. Go beyond correctness—highlight the specific mindset or habit behind each choice. Use this space to reinforce the behavioral skill the scenario is designed to strengthen. Encourage the learner with thoughtful insights, even for incorrect answers. Focus on what learners become more aware of or gain general capacity in, without suggesting *how* to behave. Feedback for correct options can begin or end with positive or encouraging or celebratory words.

12C) Behavioral Integrity Requirement:  All scenario choices and feedback must clearly reflect the behavioral concept or model provided in the topic or source content. Correct choices must show practical application of the concept or model. Incorrect choices must reflect common mistakes or misconceptions in applying it. The feedback must explicitly link the learner’s decision to the model, clarifying how it aligns or misaligns with it. This ensures the scenario serves as a practical simulation—not just a general workplace conversation. The end goal is for the learner to walk away with a grounded understanding of how to use the concept or model in real life—what to do (through correct choices) and what to avoid (through incorrect ones).

12D) If the topic or source content includes a named behavioral model or framework, each correct choice must explicitly apply a part of that model, and each incorrect choice must reflect a common misstep in applying it. Feedback must name the model directly, explain how the learner’s choice aligns or misaligns with specific components of the model, and reinforce understanding of how to use it in practice. This ensures the scenario builds both intuitive and practical mastery of the model—not just general behavioral judgment.

12E) Depth and Scenario Realism Requirement: The scenario must not simplify or generalize the behavioral challenges. Avoid safe, surface-level dilemmas. Each interaction must include realistic complexity, ambiguity, and consequences that require judgment and reflection. Every choice should reflect real-world nuance—especially the incorrect ones. Don’t write obviously wrong or irrelevant responses. Every decision must represent a perspective a well-meaning professional might sincerely consider. Avoid flattening the model or concepts into vague or interchangeable behaviors.

12F) Dialogue after each feedback to continue the story further on a common track, except in case of replay points (explained below) and repeat questions. This would typically have something that the player says, in order to take the story back to the common path, or it could be a couple of dialogues between the player and non-player. In case of wrong answers, this dialogue should indicate that the situation is not ideal. The dialogue after the feedback should always helps bring back the story onto one common path, irrespective of whether the choice made by a learner was right or wrong. In case of repeat question, there will be no dialogue after feedback as the learner has to try the question again. After feedback, it should mention that it’s a repeat question.

12G) Each interaction must be preceded by a line of dialogue from the NPC, not the Player. The NPC’s dialogue must reveal a specific concern, emotion, or question. This gives the Player something meaningful to respond to. Do not let the Player speak immediately before an interaction. Avoid situations where the Player poses a question and then “answers themselves” through the interaction options. This breaks narrative flow and realism.

12H) Do not place an interaction directly after a generic greeting or vague request—ensure the NPC’s line creates a real decision point that invites a response.

12I) Narrative Continuity Requirement: The story must make narrative sense regardless of the choice made. Ensure that each option’s response and feedback connect smoothly to the next part of the story, even if the learner chose a wrong answer. If the shared transition dialogue (used after all feedbacks) only fits one or some responses, add a bridging dialogue after the feedback for the other options. This can be a short reflection or acknowledgement from the Player that emotionally or logically links to the common transition. These bridging dialogues should flow naturally and preserve realism. It should preferably be a single dialogue, and not a series of dialogues and an actual dialogue said by a character and not a visual description (eg. You nod, noticing Priya looks even more anxious is not a dialogue). Avoid sudden jumps in tone or topic. This ensures that the scenario feels like a coherent, unfolding conversation regardless of the path taken.

12J) **VERY IMPORTANT**: Transition Continuity & Bridging Dialogue Rule: After feedback, ensure that any shared transition dialogue makes logical and emotional sense regardless of which option was selected (except in cases of repeat questions or replay points). Before writing a shared transition dialogue, you must verify that the Player’s and NPC’s response in each option logically supports that transition.
    - **MANDATORY VALIDATION STEP BEFORE TRANSITION DIALOGUE:**
        After writing all option responses and feedback, you must pause and simulate the flow of dialogue from each option through to the planned transition.
        For each path:
        - Does the most recent exchange—whether it ends with the NPC or includes Player dialogue—set up the transition naturally?
        - Does the tone, action, or reference in the transition logically follow from what the player and NPC just said—no matter which option was chosen?
        If the answer is no for any path, you must insert a **bridging dialogue** that shifts tone or topic to make the transition fit.
        **Do not proceed** to write the transition unless it fits **every** option path without emotional or narrative contradiction. 
        Do not assume the correct option’s outcome as the anchor for the transition. The transition must reflect only what is *consistently* true across all paths, or be prefaced with bridging lines that make it true.
        Approve each transition only after explicitly stating for EACH option how the transition is coherent. This check must be documented in your working memory for every interaction—do not display or print your bridging validation steps or the bridging validation logic.
    - When writing transition dialogue:
        i) Never generate different transition dialogues for each option within the same interaction. Only shared transition dialogues should appear after each interaction.
        ii) Do not refer to specific learner actions unless those occurred in all branches. Avoid phrases like “Now that you mention it” or “As you said earlier” unless the learner’s prior dialogue actually included that idea.
        iii) Ensure the NPC’s emotional tone in the transition aligns with their most recent emotional state. If the previous exchange was uncertain, hesitant, or unresolved, do not jump to a resolved or grateful tone without first showing how that shift occurred.
        iv) Ensure that any content, suggestion, or new concept stated by the NPC in the transition must have been either previously introduced or plausibly set up by the Player in every path. If a new idea is stated by the NPC that has not appeared in the Player’s input, the bridging dialogue must include the Player introducing or hinting at this idea. Never have the NPC “jump ahead” to a specific concept that hasn’t clearly emerged from all Player/NPC interactions in that path. If needed, reword either the Player’s or NPC’s prior line to properly set up the transition for all possible routes.
        v) If a bridging dialogue includes a prompt for more input from the NPC (e.g., “Walk me through your process”), the NPC must respond with a full follow-up line within the bridging dialogue—before the transition dialogue appears. 
        vi) **Critical Bridging Dialogue Rule:** If the correct answer introduces a new behavior/model element not present in other responses, and if the shared transition references this, a bridging dialogue is required in every incorrect path to introduce the same idea.
        After every incorrect response (except in Replay Point or Repeat Question cases), the Player’s bridging dialogue must be chosen according to the nature of the transition dialogue that follows:
        aa) If the transition dialogue contains a specific behavior, suggestion, idea, or concept that the NPC is responding to or agreeing with:
        - The Player must first acknowledge the NPC’s concern or reaction.
        - The Player must then explicitly propose or revisit the *core model element/behavior* indicated in the correct answer—restating or reorienting the conversation toward that behavioral step, even if it was missing previously.
            - Do not write bridging lines that are only passive, reflective, or emotionally affirming without moving toward the desired behavior or model element.
            - Example: *Player: You’re right, Elanor. Maybe instead of waiting, we could substitute one of the standard blooms for something new, like moonvine?*
        bb) If the transition dialogue is neutral (simply moving the story forward, without referencing a specific idea from the player’s right answer):
        - The Player’s bridging dialogue may also be neutral, acknowledging the NPC and naturally continuing the conversation without restating the core model element.
        In all cases:
        - The scenario’s flow should be emotionally coherent and logical for all bridging and transition dialogues, regardless of which answer was chosen.
        - Always check that the conversation makes sense from every possible path.

12K) Between each decision point, there can be dialogues between the player and non-player that help create a transition so that the scenario flows well like a story or movie script. Transitions must be via dialogues, not via notes. These are not specific to an option—they appear after the interaction, and link one interaction to another. Ensure the transition dialogue reflects what the NPC actually said in the player’s selected option. Avoid generic transitions. Customize per path so the storyline stays coherent.

12L) Each choice, even incorrect and partially correct ones, must eventually lead to the transition dialogue so the story can continue naturally. So, in cases where the player makes an incorrect choice and the Non-Playing Character responds negatively, we may need a dialogue after the feedback so that the response after the incorrect choice can link to the transition dialogue.
There should be no missing links after a choice, or no case where the transition dialogue does not make sense after the response or after the dialogue post the feedback. (eg. there should be no cases where the response / dialogue after feedback has a question that the non-playing character asked, but the transition dialogue speaks of some other topic).

12M)**Transition Neutrality Rule:** All transition dialogues between scenario blocks must remain neutral and never reference, label, hint, or foreshadow the next behavioral step, model component, or correct response expected in the following interaction. Do not use explicit or implied cues, synonyms, or examples tied to the next skill being tested. Transition dialogue may focus only on the general context, motivation, or uncertainty—never on "what to do next" or specific techniques. If needed, use generic or emotionally reflective speech to ensure the story flows naturally without giving away the next correct answer.

12N) Please do keep in mind that:
i) Sometimes when you write a scenario, the transitions between scenarios only make sense if the player has chosen the right option. In case of wrong options, the transition dialogue does not fit into the context of the response. Could you please ensure that doesn't happen, and any transition dialogue makes sense regardless of the previous option chosen? If need be, we can add dialogues after feedback to seamlessly integrate the response for wrong options into the transitional dialogue.
ii) Sometimes the dialogue after the feedback says something and the transition dialogue says something or has a note that abruptly connects the previous interaction to the next. Ideally the entire scenario should be like a naturally flowing conversation where the dialogues make a comprehensive story.
iii) The dialogue after feedback is not a reply to the feedback, it is a reply to the response of the Non-playing character. 

13) Other than that, the entire scenario must be designed as dialogues between the player, the non-playing character, and feedback. Every dialogue can be titled as *Dialogue*. Any context throughout the story can be titled as *Note*. Each interaction must include an overall question posed to the learner, for example, *Interaction 1: What would you say to the Non-Playing Character?* The question should fit in with the dialogue prior to it. Titles can appear in the same line as the dialogues.

14) The typical path would: Intro Note, then Dialogues, then Interaction 1-Options-Response-Feedback-Dialogue, the common connecting dialogues between the previous dialogue and interaction 2, then Interaction 2 and so on. The Intro Note shouldn't give away the right approaches, or should not specify which approaches are expected out of the learner.

15) Sometimes, where the wrong option is an absolute no-no or it's a critical error,  (e.g., where the conversation could naturally end or lead to a breakdown) the choice can lead to a Replay Point. In such cases, you can give the learner feedback and ask the learner to try again from the beginning. Feedback here can be titled *Replay Point Feedback*. In case of replay points, there will be no transition dialogue. Ensure that at least one decision point in the scenario includes an option that leads to a Replay Point—there can be more as well. We can avoid replay points in the first interaction.

16) In cases where a wrong option is a less critical misstep, we can either continue to the next block or ask the learner to try the same interaction again. This means the learner is retrying the same interaction (not going back to an earlier one).  In cases of repeat question, label the navigation as "Repeat Question". This means the learner is retrying the same interaction (not going back to an earlier one). Use "Replay Point" only if the story resets to the beginning.

17) Replay Point and Repeat Question labeling: When a feedback is a Replay Point, make sure both the feedback label ("Replay Point Feedback") and the navigation ("Replay Point") match, and no follow-up dialogue is provided. When feedback is just for a Repeat Question, label as "Feedback" with navigation as "Repeat Question." Never mix these.

18) Replay & Repeat Navigation Rule:

- Do not insert system-style labels like “Note: This is a Replay Point” or “Note: This is a Repeat Question.”
- Instead, for Replay Points, embed the retry instruction within the feedback text itself, using a natural, encouraging tone (e.g., “Let’s try that again from a different angle.”)
- For Repeat Questions, do not append a note to the feedback. Instead, include a separate line entry after the feedback that simply says: Repeat Question
    This should appear on its own line and be treated as a navigation command, not part of the feedback text.

19) Wherever possible, transition dialogues should reflect the emotional and narrative continuity of the scenario. If different options evoke different NPC responses (e.g., frustration, hope, relief), use bridging dialogue after the feedback to emotionally reconnect to the common transition. The story must feel coherent no matter what the player selected.

20) In some learning formats, feedback may be delivered immediately after each decision, while in others, feedback may be compiled and shown collectively at the end of the scenario. Please write each scenario so that it stands on its own and makes logical sense regardless of when feedback is displayed in the UI.

21) In all conversations, the NPC should be the main subject. Any references to others must clearly connect to how those others affect or relate to the NPC’s own experience, feelings, or challenges. The NPC should not seek advice for others but only for themselves. 

22) Ensure that the entire scenario sounds like a cohesive story that flows naturally from interaction to interaction and then to a conclusive end. 

23)The overall language of the scenario must be conversational and informal, but in a professional setting. The scenario can summarize the key learnings at the end as takeaways.

24) Please ensure your scenario includes the following too:

### Before the beginning of the scenario—Overview:

- Title: Create a 2-word catchy title for the game. Example: “Client Gambit”, “Pitch Perfect”, “Throne Tangle”.
- NPC Name: Suggest a First Name for the Non-Playing Character (One word first name).
- Skills: List 2–3 skills central to the topic shared, stated in 1–2 words each. Do not list unrelated or generic skills. Always align with the topic provided.
- Storyline:  Craft a short and intriguing narrative setup for the scenario (3-4 sentences). This should not reveal the expected behavior or give away what the learner should be doing. It should end with a challenging question (Eg. How would you navigate the situation). When writing the storyline and challenge question, avoid any language that directly or indirectly suggests what the learner *should* do or what the correct mindset is. Do not use verbs or phrases that imply an action or outcome or desired emotional states or process steps (e.g., "unlock," "help," "build trust," "solve," "navigate successfully," "win", “understand”, “support”,). Instead, keep the scenario open-ended and neutral, focusing on describing the situation or emotional tone, and end with a broad question that invites reflection or decision-making without bias.
- Learning Outcomes: Write 2–3 bullets on what learners can expect to get better at, without telling them *how* to behave. Use outcome language that reflects growth. Just like the storyline, never hint the learner at the expected behaviour. Do not reference correct or incorrect actions/behaviors. Do not contrast right vs. wrong approaches (e.g., ‘taking charge vs. deflecting’). Do not state or suggest best practices. Do not state good practices. Instead, describe the general competency, awareness, or perspective learners will expand relevant to the scenario topic.

### At the beginning of the scenario:

- Intro Note: A shorter version of the storyline that sets the context for the learner. Again, this will be worded neutrally and not hint the learner to*wards what an ideal outcome should be. There will be no visual descriptions of what the characters are doing—eg. sitting, standing, looking somewhere.*

### At the end of the scenario:

a. Final NPC Dialogue
    
    Add a final line of dialogue from the NPC that naturally concludes the story. The final dialogue between the NPC and player provides a natural emotional close, with the NPC reflecting on what shifted during the conversation (not skipping ahead to a thank-you). The conversation should flow *from the last question asked*, not feel disconnected.  After writing, review the closing exchange for abrupt or illogical shifts—revise as needed so it flows like a real conversation.
    
b. Concluding Note
    
    Include a short note (2–3 sentences) summarizing the key learning or insight from the scenario.
    
c. Design Completion Section:
    
    Provide the following as structured fields (do not include in block format): Do not reuse generic or placeholder messages or examples as suggested below. Instead, write custom messages that reflect the specific skills, behaviors, or mindset emphasized in the scenario.
    
    STRICT rule: Do not exceed the character limits suggested below.
    
    - Badge Name (14 characters max): A short, skill-focused label for the badge. The badge name should reflect the behavioral skill or quality emphasized in the scenario.
        
        E.g., "Trust Builder", "Curiosity Master", “Champion”. It should make sense too.
        
    - Completion Message -  Default (max 80 characters):
    
           E.g., *Congrats! You completed the challenge. Keep practicing for mastery!*
    
    - Completion Message -  For More than Distinction Score (max 80 characters):
    
           E.g., *Bravo! You cracked it. Badge earned and skill leveled up!*
    
    - Completion Message – For More Than Minimum Score (max 80 characters):
        
        E.g., *So close! A sharper choice could help you ace it.*
        
    - Completion Message – For Less Than Minimum Score  (max 80 characters):
        
        E.g. *You can do better! Every misstep is a step toward mastering the skill.*
        
    - Takeaways (5–6 bullet points):
        
        Share clear, non-repetitive behavioral insights from the scenario. If the scenario is based on a named behavioral model, at least 3–4 takeaways should refer to the elements of that model.
        
        E.g.:
        
        - Think from the other person’s perspective before responding
        - Look for root causes, not just surface-level symptoms
    - Thank-you Note (max 200 characters):
        
        A friendly message to close out the experience.
        
        E.g., *Thanks for playing with purpose! Keep applying what you’ve learned in every conversation that counts.*
        

25) The entire scenario must be based in the setting of the ${formData.setting}. Accordingly, the story, the problems being discussed and the names must be representative of that era. However, the language used should always reflect today’s era, regardless of the scenario setting. Please only share the final scenario.`;

    if (uploadedFile && fileContent.trim() !== '') {
      updatedPrompt += `\\n\\nPlease use the following parsed content as your primary source:\\n\\n${trimmedText}`;
    }

    if (formData.setting.trim() !== '') {
      updatedPrompt += `\nThe entire scenario must be based in the setting of the ${formData.setting}. Accordingly, the introductory note, the story, the language, the dialogues between the players, the problems being discussed and the names must be representative of that era.`;
    }

    setPrompt(updatedPrompt);
    onSend(updatedPrompt, true);
    setMessages((prev: any) => [
      ...prev,
      {
        message: updatedPrompt,
        sender: 'user',
        hidden: true,
        fromStoryForm: true,
      },
    ]);
    setShowGpt(true);
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <Box
        position={'fixed'}
        top={'20px'}
        right={'20px'}
        height={{ base: '78%', xl: '85%' }}
        width={{ base: '60%', md: '44%', xl: '35%' }}
        background={'#fff'}
        zIndex={9999999}
        borderRadius={'8px'}
        padding={'5px 5px 50px 5px'}
        border={'3px solid #11047a'}
        transform={
          trans
            ? 'scale(0.5) translate(30px 100px)'
            : 'scale(1) translate(0px 0px)'
        }
        transition="transform 0.3s ease-in-out"
      >
        {!showGpt && (
          <div className="app">
            <button
              style={{ float: 'right', marginTop: '-25px' }}
              onClick={() => setShowChat(false)}
            >
              X
            </button>
            <h1 className="app-title">AI Story</h1>
            <p className="app-description">
              Want to create an instant story for your game? ChatGPT is here to
              help!
            </p>
            <form onSubmit={handleSubmit} className="app-form">
              <div className="form-group">
                <label htmlFor="topic" className="form-label">
                  What would you like to teach?
                </label>
                <textarea
                  id="topic"
                  name="topic"
                  value={formData.topic}
                  onChange={handleChange}
                  className="form-textarea"
                  placeholder="Describe the topic - eg. conflict management skills for pharma sales professionals, with focus on active listening and effective communication."
                />
              </div>
              <div
                className="form-group"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
              >
                <label
                  className="form-label"
                  style={{
                    marginTop: '-25px',
                    fontSize: '14px',
                    fontWeight: 'normal',
                    color: '#64748b',
                  }}
                >
                  Or upload a file with your course material:
                </label>
                <div
                  style={{
                    border: '3px dashed #ccc',
                    padding: '4px',
                    textAlign: 'center',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    background: '#f9f9f9',
                  }}
                  onClick={() => document.getElementById('fileInput')?.click()}
                >
                  {uploadedFile ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span>📎 {uploadedFile.name}</span>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setUploadedFile(null);
                          setFileError(null);
                          if (fileInputRef.current) {
                            fileInputRef.current.value = ''; // ✅ Reset file input value
                          }
                        }}
                        style={{
                          marginLeft: '10px',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          color: 'red',
                          fontSize: '14px',
                        }}
                        title="Clear File"
                      >
                        ✖
                      </button>
                    </div>
                  ) : (
                    <span
                      style={{
                        fontSize: '0.875rem',
                        color: ' rgb(156, 163, 175)',
                      }}
                    >
                      Drop your file here or click to upload <br /> DOCX, PDF,
                      TXT, PPTX, XLSX • Max 5MB
                    </span>
                  )}
                </div>
                <input
                  type="file"
                  id="fileInput"
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                  accept=".ppt,.pptx,.xls,.xlsx,.txt,.doc,.docx,.pdf"
                />
                {fileError && (
                  <p style={{ color: 'red', marginTop: '8px' }}>{fileError}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="decisionPoints" className="form-label">
                  How many interactions would you like?
                </label>
                <input
                  type="text"
                  id="decisionPoints"
                  name="decisionPoints"
                  value={formData.decisionPoints}
                  onWheel={(e) => e.currentTarget.blur()}
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  className="form-input"
                  placeholder="Enter the number of interactions you want"
                />
              </div>
                          {/* <div className="form-group">
  <label htmlFor="decisionPoints" className="form-label">
    Which Quest do you want to select?
  </label>
  <select
    id="Quest"
    name="Quest"
    value={formData.Quest}
    onChange={handleChange}
    className="form-input"
  >
    <option value="">Select a quest</option>
    {[1, 2, 3, 4, 5].map((num) => (
      <option key={num} value={num}>
        {num}
      </option>
    ))}
  </select>
</div> */}
 {/* <div className="form-group">
      <label htmlFor="Quest" className="form-label">
        Which Quest do you want to select?
      </label>
      <select
        id="Quest"
        name="Quest"
        value={formData.Quest}
        onChange={handleChange}
        className="form-input"
      >
        {[1, 2, 3, 4, 5].map((num) => (
          <option key={num} value={num}>
            {num}
          </option>
        ))}
      </select>
    </div> */}

    
   {/* {availableQuests.length > 1 && ( */}
  {/* // <div className="form-group">
  //   <label htmlFor="Quest" className="form-label">
  //     Which Quest do you want to select?
  //   </label>
  //   <select */}
  {/* //     id="Quest"
  //     name="Quest"
  //     value={formData.Quest || ""}
  //     onChange={handleChange}
  //     className="form-input"
  //   > */}
  {/* //     {availableQuests.map((num) => (
  //       <option key={num} value={num}>
  //         {num}
  //       </option>
  //     ))}
  //   </select>
  // </div>
// )} */}

  
              <div className="form-group">
                <label htmlFor="options" className="form-label">
                  How many options per interaction?
                </label>
                <input
                  type="text"
                  id="options"
                  name="options"
                  value={formData.options}
                  onWheel={(e: any) => e.currentTarget.blur()}
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  className="form-input"
                  placeholder="Enter the number of options you want for each Interaction"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="setting" className="form-label">
                  What should the overall setting be? (Optional)
                </label>
                <input
                  type="text"
                  id="setting"
                  name="setting"
                  value={formData.setting}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Eg. A futuristic office in 2050, where the NPC is a female client"
                />
              </div>
              <div style={{ display: 'flex' }}>
                <button
                  onClick={() => setShowGpt(true)}
                  className="submit-button-cancel"
                >
                  Cancel
                </button>
                <button type="submit" className="submit-button">
                  Submit
                </button>
              </div>
            </form>
            {apiResponse && (
              <div className="response-container">
                <h3>API Response:</h3>
                <pre>{apiResponse}</pre>
              </div>
            )}
          </div>
        )}

        {showGpt && (
          <>
            <div
              style={{
                paddingBottom: '10px',
                paddingTop: '10px',
                textAlign: 'center',
                backgroundColor: '#11047a',
                borderRadius: '8px 8px 0px 0px',
              }}
            >
              <button
                style={{ float: 'right', color: 'white', marginRight: '10px' }}
                onClick={() => setShowChat(false)}
              >
                X
              </button>
              <h2
                style={{
                  fontSize: '18px',
                  fontWeight: 'bold',
                  margin: '0',
                  color: '#fff',
                }}
              >
                ChatGPT
              </h2>
            </div>
            <div
              style={{
                width: '95%',
                position: 'absolute',
                zIndex: 9,
                bottom: `${inputHeight + 40}px`, // +40 for spacing
                display: 'flex',
              }}
            >
              <div
                style={{
                  width: '100%',
                }}
              >
                {isTyping && (
                  <div
                    style={{
                      color: 'gray',
                      fontSize: '14px',
                      backgroundColor: 'white',
                      marginBottom: '8px',
                      height: '23px',
                    }}
                  >
                    <TypingIndicator
                      style={{ padding: '5px' }}
                      content="ChatGPT is typing"
                    />
                  </div>
                )}
                <button
                  className="submit-button-story"
                  onClick={() => setShowGpt(false)}
                >
                  Create Story With AI <Icon as={GiVintageRobot} ml={2} />
                </button>
              </div>
            </div>
            <MainContainer
              style={{
                padding: '10px 0px',
                borderRadius: '0px 0px 8px 8px',
                border: 'none',
              }}
            >
              <ChatContainer>
                <MessageList
                  ref={messageListRef}
                  className="custom-message-list"
                  id="messagelist-scrollbar"
                  scrollBehavior="smooth"
                  style={{ marginBottom: '4em', overflowY: 'auto' }}
                >
                  {messages.map((message, i) => {
                    const isLast = i === messages.length - 1;
                    const isStoryMessage = (() => {
                      if (message?.sender !== 'ChatGPT' || !message.message)
                        return false;
                      const msg = message.message.toLowerCase();
                      return (
                        msg.includes('learning outcome') ||
                        msg.includes('overview')
                      );
                    })();

                    return (
                      <div
                        key={i}
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems:
                            message?.sender === 'ChatGPT'
                              ? 'flex-start'
                              : 'flex-end',
                        }}
                      >
                        <div
                          style={{
                            width: '80%',
                            overflowY: 'auto',
                            marginBottom: isLast && isTyping ? '35px' : '0',
                          }}
                        >
                          {!message?.hidden && (
                            <ScaleFade initialScale={0.9} in={true}>
                              <div
                                style={{
                                  padding: '10px',
                                  background:
                                    message?.sender === 'ChatGPT'
                                      ? '#d9ebf7'
                                      : '#e3e3e3',
                                  borderRadius:
                                    message?.sender === 'ChatGPT'
                                      ? '0 .7em .7em .7em'
                                      : '.7em 0 .7em .7em',
                                  marginTop: '10px',
                                  whiteSpace: 'pre-wrap',
                                  lineHeight: '1.6',

                                  marginBottom:
                                    isLast && isTyping ? '35px' : '0',
                                }}
                                className={'text_chatgpt'}
                              >
                                {message?.message}
                              </div>
                            </ScaleFade>
                          )}
                        </div>
                        {isStoryMessage && (
                          <div
                            style={{
                              display: 'flex',
                              gap: '10px',
                              marginTop: '10px',
                            }}
                          >
                            <button
                              className="use-story-button"
                              onClick={() => handleStory(message.message)}
                            >
                              Use Story
                            </button>
                            <button
                              className="use-story-button"
                              onClick={() => {
                                navigator.clipboard.writeText(message?.message);
                                toast({
                                  title: 'Story copied successfully.',
                                  status: 'success',
                                  duration: 2000,
                                  isClosable: true,
                                  containerStyle: { zIndex: 1 },
                                });
                              }}
                            >
                              Copy
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  <div ref={lastMessageRef} />
                </MessageList>
                <MessageInput
                  placeholder="Message ChatGPT..."
                  onSend={(message) => onSend(stripHtmlTags(message), false)}
                  attachButton={false}
                  sendButton={true}
                />
              </ChatContainer>
            </MainContainer>
          </>
        )}
      </Box>
    </>
  );
};
export default ChatPopup;
